module.exports = __webpack_public_path__ + "static/img/t12.a3858091.png";